/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { WDHImage } from '@demant/wdh';
import { withReactBootstrap } from '@demant/wdh-react-bootstrap';
var BlogRelatedApp = function BlogRelatedApp(_ref) {
  var settings = _ref.settings;
  var list = settings.relatedList;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "related-blogs-component"
  }, /*#__PURE__*/React.createElement("div", {
    className: "related-title"
  }, /*#__PURE__*/React.createElement("h2", null, settings.relatedTitle.text)), /*#__PURE__*/React.createElement("div", {
    className: "related-blog-list"
  }, list.map(function (item, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: "related-list-item",
      key: index
    }, /*#__PURE__*/React.createElement("a", {
      href: item.link.href,
      className: "related-list-item-content"
    }, /*#__PURE__*/React.createElement("div", {
      className: "news-image"
    }, /*#__PURE__*/React.createElement(WDHImage, {
      image: item.image
    })), /*#__PURE__*/React.createElement("div", {
      className: "news-date"
    }, item.date), /*#__PURE__*/React.createElement("div", {
      className: "news-title"
    }, item.title), /*#__PURE__*/React.createElement("div", {
      className: "news-text"
    }, item.text), /*#__PURE__*/React.createElement("div", {
      className: "news-link"
    }, item.newsLink)));
  }))));
};
export default withReactBootstrap(BlogRelatedApp);